import { Component, type ReactNode } from 'react';

import { reportClientDiagnostic } from '../api/clientDiagnostics';

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  hasError: boolean;
}

export class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  public state: AppErrorBoundaryState = { hasError: false };

  public static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  public componentDidCatch(): void {
    reportClientDiagnostic({
      event_code: 'fatal_render_error',
      outcome: 'failed',
      route_category: 'unknown',
      timing_bucket: 'not_recorded',
    });
  }

  public render() {
    if (this.state.hasError) {
      return (
        <main className="fatal-error" role="alert" aria-labelledby="fatal-title">
          <div className="fatal-error__panel">
            <p className="eyebrow">Application error</p>
            <h1 id="fatal-title">Flow Wizard could not render this view</h1>
            <p>
              Your local project data has not been changed. Reload the application
              to try again.
            </p>
            <button
              className="button button--primary"
              type="button"
              onClick={() => window.location.reload()}
            >
              Reload application
            </button>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}
